"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _toConsumableArray2 = _interopRequireDefault(require("@babel/runtime/helpers/toConsumableArray"));

var _FormattedMessage = _interopRequireDefault(require("I18n/components/FormattedMessage"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _createReactClass = _interopRequireDefault(require("create-react-class"));

var _react = _interopRequireDefault(require("react"));

var _draftJs = require("draft-js");

var _draftExtend = require("draft-extend");

var _createPluginStack = require("../createPluginStack");

var _SmallToggleButton = _interopRequireDefault(require("../../components/SmallToggleButton"));

var _usageTracker = require("../../tracking/usageTracker");

var _isImageBlock = _interopRequireDefault(require("../../utils/isImageBlock"));

var _LinkDecorator = _interopRequireDefault(require("./LinkDecorator"));

var _LinkPopoverDecorator = _interopRequireDefault(require("./LinkPopoverDecorator"));

var _getNormalizedLinkData = _interopRequireDefault(require("./getNormalizedLinkData"));

var _MutableEntityWithBoundaries = _interopRequireDefault(require("draft-plugins/plugins/MutableEntityWithBoundaries"));

var _createLinkEntityOptions = _interopRequireDefault(require("draft-plugins/utils/createLinkEntityOptions"));

var _removeEntitiesFromBlock = _interopRequireDefault(require("draft-plugins/utils/removeEntitiesFromBlock"));

var _keyCodes = require("draft-plugins/lib/keyCodes");

var _constants = require("draft-plugins/lib/constants");

var _UIButton = _interopRequireDefault(require("UIComponents/button/UIButton"));

var _classnames = _interopRequireDefault(require("classnames"));

var entityStrategy = _draftExtend.pluginUtils.entityStrategy,
    isEntityActive = _draftExtend.pluginUtils.isEntityActive;
var Tracker;
var DEFAULT_OPTIONS = {
  Decorator: _LinkDecorator.default,
  PopoverDecorator: _LinkPopoverDecorator.default,
  entityOptionCreator: _createLinkEntityOptions.default,
  showNoFollow: false,
  showTarget: true,
  hideTargetConfiguration: false,
  hideNoFollowConfiguration: false,
  onOpenPopover: function onOpenPopover() {},
  onInsertLink: function onInsertLink() {},
  tooltipPlacement: 'bottom',
  useUnstyledButton: false
};

var selectionSplitsLink = function selectionSplitsLink(editorState) {
  var selection = editorState.getSelection();

  if (!selection.isCollapsed()) {
    return _draftJs.RichUtils.currentBlockContainsLink(editorState);
  }

  var anchorOffset = selection.getAnchorOffset();
  var focusOffset = selection.getFocusOffset();

  if (anchorOffset === 0 && focusOffset === 0) {
    // at the start of a line, don't need to split anything
    return false;
  }

  var contentState = editorState.getCurrentContent();
  var selectedBlockCharList = contentState.getBlockForKey(selection.getAnchorKey()).getCharacterList();
  var charBeforeCursor = selectedBlockCharList.get(anchorOffset - 1);
  var charAfterCursor = selectedBlockCharList.get(anchorOffset);
  var entityKeyBeforeCursor = charBeforeCursor && charBeforeCursor.getEntity();
  var entityKeyAfterCursor = charAfterCursor && charAfterCursor.getEntity();

  if (entityKeyBeforeCursor == null || entityKeyAfterCursor == null) {
    return false;
  }

  var entityBeforeCursor = contentState.getEntity(entityKeyBeforeCursor);
  var entityAfterCursor = contentState.getEntity(entityKeyAfterCursor);
  return !!entityBeforeCursor && !!entityAfterCursor && entityBeforeCursor.getType() === 'LINK' && entityAfterCursor.getType() === 'LINK';
};

var _default = function _default() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  if (!Tracker) {
    Tracker = (0, _usageTracker.createTracker)();
  }

  var optionsWithDefaults = Object.assign({}, DEFAULT_OPTIONS, {}, options, {
    Tracker: Tracker
  });
  var Decorator = optionsWithDefaults.Decorator,
      PopoverDecorator = optionsWithDefaults.PopoverDecorator,
      entityOptionCreator = optionsWithDefaults.entityOptionCreator,
      useUnstyledButton = optionsWithDefaults.useUnstyledButton,
      tooltipPlacement = optionsWithDefaults.tooltipPlacement;

  var htmlToEntity = function htmlToEntity(nodeName, node, createEntity) {
    if (nodeName === 'a' && node.parentNode.nodeName !== 'FIGURE') {
      var url = node.getAttribute('href');
      var isNoFollow = node.getAttribute('rel') === 'nofollow';
      var isTargetBlank = node.getAttribute('target') === '_blank';
      return createEntity.apply(void 0, (0, _toConsumableArray2.default)(entityOptionCreator(url, isTargetBlank, isNoFollow)));
    }

    return undefined;
  };

  var entityToHTML = function entityToHTML(entity, originalText) {
    var data = entity.data;

    if (entity.type === _constants.LINK_ENTITY_TYPE) {
      var showNoFollow = optionsWithDefaults.showNoFollow,
          showTarget = optionsWithDefaults.showTarget;

      var _getNormalizedLinkDat = (0, _getNormalizedLinkData.default)(data, {
        showNoFollow: showNoFollow,
        showTarget: showTarget
      }),
          url = _getNormalizedLinkDat.url,
          isNoFollow = _getNormalizedLinkDat.isNoFollow,
          isTargetBlank = _getNormalizedLinkDat.isTargetBlank;

      var attrs = {
        href: url
      };

      if (isNoFollow) {
        attrs.rel = 'nofollow';
      }

      if (isTargetBlank) {
        attrs.target = '_blank';
      } else {
        // explicitly add self target for copy & paste use case
        attrs.target = '_self';
      }

      return _react.default.createElement("a", attrs);
    }

    return originalText;
  };

  var keyBindingFn = function keyBindingFn(e) {
    if (e.keyCode === _keyCodes.K && _draftJs.KeyBindingUtil.hasCommandModifier(e)) {
      return 'toggle-link';
    }

    return undefined;
  };

  var tooltip = _react.default.createElement(_FormattedMessage.default, {
    message: "draftPlugins.linkPlugin.tooltip"
  });

  var LinkButton = (0, _createReactClass.default)({
    displayName: "LinkButton",
    propTypes: {
      addKeyCommandListener: _propTypes.default.func.isRequired,
      editorState: _propTypes.default.object.isRequired,
      disabled: _propTypes.default.bool,
      open: _propTypes.default.bool,
      removeKeyCommandListener: _propTypes.default.func.isRequired,
      togglePopover: _propTypes.default.func.isRequired
    },
    getDefaultProps: function getDefaultProps() {
      return {
        disabled: false
      };
    },
    componentDidMount: function componentDidMount() {
      this.props.addKeyCommandListener(this.handleKeyCommand);
    },
    componentWillUnmount: function componentWillUnmount() {
      this.props.removeKeyCommandListener(this.handleKeyCommand);
    },
    isLinkSelected: function isLinkSelected() {
      var editorState = this.props.editorState;
      var isTextLink = isEntityActive(editorState, _constants.LINK_ENTITY_TYPE);

      if (isTextLink) {
        return true;
      }

      var currentSelection = editorState.getSelection();
      var currentBlockKey = currentSelection.getFocusKey();
      var currentContent = editorState.getCurrentContent();
      var currentBlock = currentContent.getBlockForKey(currentBlockKey);

      if (!currentBlock) {
        return false;
      }

      var isImageSelected = (0, _isImageBlock.default)(currentBlock);

      if (!isImageSelected) {
        return false;
      }

      var imageBlockData = currentBlock.getData();
      return Boolean(imageBlockData.getIn(['link', 'url'], false));
    },
    handleKeyCommand: function handleKeyCommand(editorState, command) {
      if (command === 'toggle-link') {
        this.props.togglePopover();
      }

      if (command === 'split-block' && selectionSplitsLink(editorState)) {
        var splitContent = _draftJs.Modifier.splitBlock(editorState.getCurrentContent(), editorState.getSelection());

        var targetBlockKey = splitContent.getSelectionAfter().getAnchorKey();
        var blockAfterContent = splitContent.getBlockForKey(targetBlockKey);
        var contentWithoutTrailingEntity = (0, _removeEntitiesFromBlock.default)(blockAfterContent, splitContent);

        var editorStateWithUpdatedContent = _draftJs.EditorState.push(editorState, contentWithoutTrailingEntity, 'split-block');

        return _draftJs.EditorState.forceSelection(editorStateWithUpdatedContent, _draftJs.SelectionState.createEmpty(targetBlockKey));
      }

      return undefined;
    },
    render: function render() {
      var _this$props = this.props,
          disabled = _this$props.disabled,
          isPopoverOpen = _this$props.open,
          togglePopover = _this$props.togglePopover;
      var isActive = this.isLinkSelected();

      if (useUnstyledButton) {
        var className = (0, _classnames.default)('link-plugin-unstyled-button', {
          // TODO find a less hacky way to highlight buttons when they're active
          // as children of a UIDropdown
          'private-hovered': isActive
        });

        var buttonText = _react.default.createElement(_FormattedMessage.default, {
          message: "draftPlugins.linkPlugin.unstyledButtonText"
        });

        return _react.default.createElement(_UIButton.default, {
          className: className,
          key: _constants.LINK_ENTITY_TYPE,
          onClick: togglePopover
        }, buttonText);
      }

      var isLinkSelected = isPopoverOpen || isActive;
      var isButtonActive = !disabled && isLinkSelected;
      return _react.default.createElement(_SmallToggleButton.default, {
        key: _constants.LINK_ENTITY_TYPE,
        active: isButtonActive,
        icon: "link",
        className: "link-plugin-icon",
        disabled: disabled,
        onClick: togglePopover,
        tooltip: tooltip,
        tooltipPlacement: tooltipPlacement
      });
    }
  });
  var DecoratedLinkButton = PopoverDecorator(LinkButton);
  return (0, _createPluginStack.createPluginStack)((0, _MutableEntityWithBoundaries.default)(_constants.LINK_ENTITY_TYPE), (0, _draftExtend.createPlugin)({
    displayName: 'LinkPlugin',
    buttons: DecoratedLinkButton(entityOptionCreator, optionsWithDefaults),
    decorators: {
      strategy: entityStrategy(_constants.LINK_ENTITY_TYPE),
      component: Decorator(entityOptionCreator, optionsWithDefaults),
      props: optionsWithDefaults
    },
    keyBindingFn: keyBindingFn,
    htmlToEntity: htmlToEntity,
    entityToHTML: entityToHTML
  }));
};

exports.default = _default;
module.exports = exports.default;